import angular from 'angular';
import ovalTag from './ovalTag';
import './style.scss';

export default angular
  .module('components.ovalTag', [])
  .component('ovalTag', ovalTag).name;
